import React from 'react';
// hero background import removed to avoid module resolution issues; use public path instead
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Eye, CheckCircle, X, Apple } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { useEffect, useRef, useState, useCallback } from 'react';

export function HomePage() {
  const heroRef = useRef<HTMLDivElement | null>(null);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  // Home hero üstünde dönecek görseller
  const slideshowImages = ['/1.png', '/2.png', '/3.png', '/4.png'];
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  // Partikülleri, kapsayıcı yüksekliğine göre yeniden başlat
  const reinitParticles = useCallback(() => {
    const $ = (window as any).jQuery as any;
    const pg = (window as any).particleground as any;
    if (!heroRef.current || !$.fn || !pg) return;
    const containerEl = heroRef.current.parentElement as HTMLElement | null;
    if (!containerEl) return;
    const $el = $(heroRef.current);
    try { $el.particleground('destroy'); } catch {}
    const rect = containerEl.getBoundingClientRect();
    heroRef.current.style.width = `${rect.width}px`;
    heroRef.current.style.height = `${rect.height}px`;
    heroRef.current.style.top = '0px';
    heroRef.current.style.left = '0px';
    $el.particleground({
      dotColor: 'rgba(93, 101, 107, 0.35)',
      lineColor: 'rgba(93, 101, 107, 0.35)',
      parallax: true,
      parallaxMultiplier: 50
    });
  }, []);

  useEffect(() => {
    // Tema kontrolü
    const checkTheme = () => {
      const isDark = document.documentElement.classList.contains('dark');
      console.log('Tema kontrolü:', { isDark, classList: document.documentElement.classList.toString() });
      setIsDarkMode(isDark);
    };

    // İlk kontrol
    checkTheme();
    
    // Tema değişikliklerini dinle
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    
    return () => {
      observer.disconnect();
    };
  }, []);

  // Hero sağındaki görseli 4 saniyede bir değiştir
  useEffect(() => {
    if (slideshowImages.length === 0) return;
    const intervalId = window.setInterval(() => {
      setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slideshowImages.length);
    }, 5500);
    return () => window.clearInterval(intervalId);
  }, []);
  
  useEffect(() => {
    reinitParticles();
    const onResize = () => reinitParticles();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      const $ = (window as any).jQuery as any;
      if (heroRef.current && $.fn) {
        const $el = $(heroRef.current);
        try { $el.particleground('destroy'); } catch {}
      }
    };
  }, [reinitParticles]);

  // Slayt değişince (ve görsel yüklendiğinde) boyutu güncelle
  useEffect(() => {
    reinitParticles();
  }, [currentSlideIndex, reinitParticles]);
  const featuredProjects = [
    {
      slug: 'frigolive',
      title: 'Frigolive F-007',
      description: 'Tedarik zincirinizde tam kontrol: Konum, sıcaklık, nem, ışık ve darbe verileriyle hassas ürün transferlerinizi garanti altına alın.',
      image: '/frigolive-1.png',
      features: ['Canlı takip', 'GSM bağlantısı', 'Alarm sistemi','Mobil uygulama']
    },
    {
      slug: 'shalteron',
      title: 'ShalterOn',
      description: '6 röle kontrolü ve 4 dijital input ile gelişmiş otomasyon sistemi.',
      image: 'gsm_role.png',
      features: ['Bahçe Sulama','Motor Kontrolü', 'Zamanlama', 'Mobil uygulama'],
    },
    {
      slug: 'akilli-gecis-sistemi',
      title: 'Akıllı Geçiş Sistemi',
      description: 'QR kod ve mobil uygulama entegrasyonlu modern erişim kontrol sistemi.',
      image: '/kgs_1.png',
      features: ['QR kod desteği', 'Yoklama sistemi', 'Raporlama','Mobil uygulama'],
    }
  ];

  return (
    <div>
      {/* Fuar Duyuru Banner */}
      {showAnnouncement && (
        <div className="relative w-full bg-gradient-to-r from-green-600 to-green-700 text-white">
          <div
            className="absolute inset-0 bg-cover bg-center opacity-20"
            style={{ backgroundImage: "url('/cta3-bg.jpg')" }}
          />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <button
              onClick={() => setShowAnnouncement(false)}
              className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
              aria-label="Duyuruyu kapat"
            >
              <X size={20} />
            </button>
            
            <div className="pr-10">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-3">
                İlimera Teknoloji Euroasia Interfresh 2025'te!
              </h2>
              
              <div className="space-y-3 text-sm sm:text-base leading-relaxed">
                <p>
                  <span className="font-semibold">18-20 Eylül 2025</span> tarihlerinde İzmir'de düzenlenecek olan Meyve, Sebze, Gıda, Gıda Ürünleri, Gıda Teknolojileri, Ambalaj, Tarım Teknolojileri, Depolama ve Lojistik Fuarı – 
                  <span className="font-bold"> Euroasia Interfresh 2025'te biz de yerimizi alıyoruz.</span>
                </p>
                
                <p>
                  Soğuk zincir yönetimi, gıda güvenliği, akıllı lojistik ve tarım teknolojileri alanında en son yeniliklerin sergileneceği bu büyük buluşmada,
                  <span className="font-extrabold"> İLİMERA TEKNOLOJİ</span> olarak geliştirdiğimiz çözümleri sizlerle paylaşacağız.
                </p>
                
                <div className="bg-white/10 rounded-lg p-4 mt-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="font-semibold">Fuar Adresi:</span><br />
                      Zafer Sakarya Caddesi No:2 Yeni Fuar Alanı, Gaziemir/İzmir
                    </div>
                    <div>
                      <span className="font-semibold">Stand No:</span> A 10A
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Hero Section */}
      <section className="relative overflow-hidden min-h-[700px] py-16 lg:py-20">
        {/* Background image */}
        <div
          aria-hidden
          className="absolute inset-0 z-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/hero3-bg.jpg')" }}
        ></div>
        {/* Dark overlay for readability */}
        <div aria-hidden className="absolute inset-0 z-[5] bg-black/45"></div>
        {/* Particles above overlay */}
        <div ref={heroRef} id="particles" className="absolute inset-0 z-10 pointer-events-none"></div>
        {/* Subtle grid texture */}
        <div className="absolute inset-0 bg-grid-pattern opacity-5 z-[15]"></div>
          <div className="relative z-20 w-full flex justify-center">
          <div className="w-[1234px] h-[700px]">
            <ImageWithFallback
              src={slideshowImages[currentSlideIndex]}
              alt="Teknoloji ve İnovasyon"
                className="w-full h-full object-cover rounded-lg shadow-xl"
                onLoad={reinitParticles}
            />
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Öne Çıkan Ürünlerimiz
            </h2>
            <p className="text-lg text-foreground">
              İnovatif çözümlerimizle sektörde fark yaratan ürünlerimizi keşfedin
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
            {featuredProjects.map((project) => (
              <Card key={project.slug} className="overflow-hidden hover:shadow-lg transition-shadow flex flex-col h-full">
                <div className="w-full aspect-[16/9]">
                  <ImageWithFallback
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <CardContent className="p-6 flex flex-col flex-1">
                  <h3 className="text-xl font-semibold text-foreground mb-2">
                    {project.title}
                  </h3>
                  <p className="text-muted mb-4">
                    {project.description}
                  </p>
                  <ul className="mb-6 flex-1">
                    {project.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-muted-foreground mb-1">
                        <CheckCircle size={16} className="text-primary mr-2" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto space-y-2">
                    {project.slug && (
                      <Link to={`/downloads/${project.slug}`}>
                        <Button variant="outline" className="w-full group dark:bg-gray-800 dark:border-gray-800">
                          Mobil Uygulamayı Keşfedin
                          <ArrowRight className="ml-2" size={16} />
                        </Button>
                      </Link>
                    )}
                    <div className="h-1.4" /> {/* Butonlar arası boşluk */}
                    <Link to={`/urunler/${project.slug}`}>
                      <Button variant="outline" className="w-full group dark:bg-gray-800 dark:border-gray-800">
                        Detayları İncele
                        <ArrowRight className="ml-2" size={16} />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/urunler">
              <Button size="lg" className="bg-primary hover:bg-primary/90">
                Tüm Ürünleri Görüntüle
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
      
      {/* About Summary */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Teknoloji ile Hayatı Kolaylaştırıyoruz
            </h2>
            <p className="text-lg text-foreground max-w-3xl mx-auto">
              2011 yılından beri elektronik ve yazılım alanında faaliyet gösteren İlimera Teknoloji, 
              müşteri ihtiyaçlarına özel çözümler geliştiren öncü bir şirkettir.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                <Target className="text-primary" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2 transition-all duration-300 group-hover:text-primary group-hover:drop-shadow-sm relative after:block after:h-0.5 after:w-0 after:bg-primary after:mx-auto after:mt-2 after:transition-all after:duration-300 group-hover:after:w-12">Misyonumuz</h3>
              <p className="text-muted transition-colors duration-300 group-hover:text-foreground">
                Teknoloji ile hayatı kolaylaştırmak ve güvenilir çözümler üretmek
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3">
                <Eye className="text-primary" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2 transition-all duration-300 group-hover:text-primary group-hover:drop-shadow-sm relative after:block after:h-0.5 after:w-0 after:bg-primary after:mx-auto after:mt-2 after:transition-all after:duration-300 group-hover:after:w-12">Vizyonumuz</h3>
              <p className="text-muted transition-colors duration-300 group-hover:text-foreground">
                Yerli ve yenilikçi teknolojilerle global pazarda söz sahibi olmak
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-1">
                <CheckCircle className="text-primary" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2 transition-all duration-300 group-hover:text-primary group-hover:drop-shadow-sm relative after:block after:h-0.5 after:w-0 after:bg-primary after:mx-auto after:mt-2 after:transition-all after:duration-300 group-hover:after:w-12">Değerlerimiz</h3>
              <p className="text-muted transition-colors duration-300 group-hover:text-foreground">
                Kalite, güvenilirlik ve müşteri memnuniyeti odaklı yaklaşım
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Destekler Section */}
      <section className="py-12 lg:py-16 relative z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 
            className="text-3xl lg:text-4xl font-bold text-foreground mb-4"
            style={{ color: 'var(--foreground)' }}
          >
            Destekler
          </h2>
          <div className="flex justify-center items-center gap-12 mb-12">
            <img 
              src={isDarkMode ? "/tubitak-Dikey-Beyaz.png" : "/tubitak-Dikey.png"} 
              alt="TÜBİTAK" 
              className="w-auto object-contain"
              style={{ height: '98px' }}
            />
            <img 
              src={isDarkMode ? "/kosgeb-logo-beyaz.png" : "/kosgeb-logo-renkli.png"} 
              alt="KOSGEB" 
              className="w-auto object-contain"
              style={{ height: '70px' }}
            />
          </div>
        </div>
      </section>

      {/* Referanslar Section */}
      <section className="py-12 lg:py-16 relative z-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 
            className="text-3xl lg:text-4xl font-bold text-foreground mb-8"
            style={{ color: 'var(--foreground)' }}
          >
            Referanslar
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-12">
            {/* TALYA FRESH */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3" size={48} color="#c21111" />
              <span className="text-sm text-muted-foreground text-center">TALYA FRESH</span>
            </div>
            
            {/* GÜLBUDAK */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_gulbudak.avif"
                alt="GULBUDAK" 
                className="w-auto object-contain mb-3"
                style={{ height: '40px', width: '150px'}}
              />
              <span className="text-sm text-muted-foreground text-center">GÜLBUDAK</span>
            </div>
            
            {/* YER GÖK ELMA */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3 text-primary" size={48} />
              <span className="text-sm text-muted-foreground text-center">YER GÖK ELMA</span>
            </div>
            
            {/* TURKUAZ */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3" size={48} color="#c21111" />
              <span className="text-sm text-muted-foreground text-center">TURKUAZ</span>
            </div>

            {/* ÇAVSA COLD STORAGE */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_cavsa.svg"
                alt="ÇAVSA COLD STORAGE" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px' }}
              />
              <span className="text-sm text-muted-foreground text-center">ÇAVSA COLD STORAGE</span>
            </div>

            {/* TAŞBAŞ SOĞUK HAVA DEPOSU */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_tasbas.jpg"
                alt="TAŞBAŞ SOĞUK HAVA DEPOSU" 
                className="w-auto object-contain mb-3"
                style={{ height: '80px' }}
              />
              <span className="text-sm text-muted-foreground text-center">TAŞBAŞ SOĞUK HAVA DEPOSU</span>
            </div>

          {/* ONURLU FRESH FRUIT */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_onurlu.png"
                alt="ONURLU FRESH FRUIT" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px' }}
              />
              <span className="text-sm text-muted-foreground text-center">ONURLU FRESH FRUIT</span>
            </div>

            {/* ERİKÇİ TARIM */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_erikci.webp"
                alt="ERİKÇİ TARIM" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px' }}
              />
              <span className="text-sm text-muted-foreground text-center">ERİKÇİ TARIM</span>
            </div>
            
            {/* KAPAR SOĞUK HAVA */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_kapar.png"
                alt="KAPAR SOĞUK HAVA" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px', width: '170px'}}
              />
              <span className="text-sm text-muted-foreground text-center">KAPAR SOĞUK HAVA</span>
            </div>
            
            {/* SWEET TARIM */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_sweet.png"
                alt="SWEET TARIM" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px' }}
              />
              <span className="text-sm text-muted-foreground text-center">SWEET TARIM</span>
            </div>
            
            {/* GOLD FRESH */}
            <div className="flex flex-col items-center">
              <img 
                src="/ref_golfresh.png"
                alt="GOLD FRESH" 
                className="w-auto object-contain mb-3"
                style={{ height: '60px' }}
              />
              <span className="text-sm text-muted-foreground text-center">GOLD FRESH</span>
            </div>

            {/* KIREFE */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3 text-primary" size={48} />
              <span className="text-sm text-muted-foreground text-center">KIREFE</span>
            </div>

            {/* YILDIZ */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3 text-primary" size={48} />
              <span className="text-sm text-muted-foreground text-center">YILDIZ</span>
            </div>

            {/* KASAPOĞLU */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3" size={48} color="#c21111" />
              <span className="text-sm text-muted-foreground text-center">KASAPOĞLU</span>
            </div>

            {/* EKREMOĞLU */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3 text-primary" size={48} />
              <span className="text-sm text-muted-foreground text-center">EKREMOĞLU</span>
            </div>

            {/* MEYSO */}
            <div className="flex flex-col items-center">
              <Apple className="mb-3" size={48} color="#c21111" />
              <span className="text-sm text-muted-foreground text-center">MEYSO</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}